module.exports = __webpack_public_path__ + "img/fca13-m.61b3d5fc.png";